import styled from "styled-components";
import { pxToRem } from "styles/utils";

export const ReferralPageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  min-height: 0;
  margin: ${pxToRem(12)};
  box-sizing: border-box;

  @media (max-width: 1000px) {
    height: auto;
    min-height: calc(100% - ${pxToRem(24)});
  }
`;

export const ContentWrapper = styled.main`
  min-width: 0;
  min-height: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: ${pxToRem(32)} ${pxToRem(24)};
  overflow: visible;
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  box-shadow: ${({ theme }) => theme.shadows.md}, ${({ theme }) => theme.shadows.ring};
`;

export const Title = styled.h1`
  margin: 0 0 ${pxToRem(22)};
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${pxToRem(32)};
  font-weight: 700;
  letter-spacing: -0.02em;
`;

export const TopGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.55fr) minmax(0, 1fr);
  gap: ${pxToRem(15)};
  margin-bottom: ${pxToRem(15)};

  @media (max-width: 1000px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const SurfaceCard = styled.section`
  min-width: 0;
  padding: ${pxToRem(18)} ${pxToRem(20)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.borders.outline};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  background: ${({ theme }) => theme.colors.white};
`;

export const SectionTitle = styled.h2`
  margin: 0 0 ${pxToRem(14)};
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${pxToRem(18.75)};
  font-weight: 500;
`;

export const BalanceRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${pxToRem(16)};

  > button {
    width: auto;
    min-width: 0;
    max-width: none;
    flex: 0 0 auto;
  }

  @media (max-width: 1000px) {
    align-items: flex-end;
  }
`;

export const BalanceValue = styled.div`
  min-width: 0;
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${pxToRem(40)};
  font-weight: 600;
  line-height: 1;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: ${pxToRem(15)};
  margin-bottom: ${pxToRem(15)};

  @media (max-width: 1000px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const ChartCard = styled(SurfaceCard)`
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  min-height: ${pxToRem(410)};

  @media (max-width: 1000px) {
    flex: 0 0 auto;
  }
`;

export const ChartHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${pxToRem(16)};
  flex-wrap: wrap;
  margin-bottom: ${pxToRem(14)};
`;

export const ChartTitle = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${pxToRem(18.75)};
  font-weight: 500;
`;

export const Legend = styled.div`
  display: flex;
  gap: ${pxToRem(16)};
  margin-top: ${pxToRem(6)};
  color: ${({ theme }) => theme.colors.inkSoft};
  font-size: ${pxToRem(16.25)};
`;

export const LegendItem = styled.span`
  display: inline-flex;
  align-items: center;
`;

export const LegendSwatch = styled.i<{ $kind: "bar" | "line" }>`
  width: ${pxToRem(10)};
  height: ${pxToRem(10)};
  margin-right: ${pxToRem(6)};
  border-radius: ${pxToRem(3)};
  background: ${({ $kind, theme }) => ($kind === "bar" ? theme.colors.brandGlow : theme.colors.brand)};
`;

export const ChartToolbar = styled.div`
  position: relative;
  z-index: 20;
  display: flex;
  align-items: center;
`;

export const ChartBody = styled.div`
  width: 100%;
  min-width: 0;
  min-height: ${pxToRem(280)};
  flex: 1 1 0;

  @media (max-width: 1000px) {
    flex: 0 0 ${pxToRem(300)};
    height: ${pxToRem(300)};
  }
`;

export const ChartNote = styled.div`
  margin-top: ${pxToRem(12)};
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${pxToRem(16.25)};
`;

export const LoadingContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${pxToRem(420)};
`;

export const ErrorWrapper = styled.div`
  flex: 1;
  display: flex;
  min-height: ${pxToRem(420)};

  > * {
    flex: 1;
  }
`;

export const ChartEmptyWrapper = styled.div`
  display: flex;
  height: 100%;
  min-height: 0;

  > * {
    flex: 1;
  }
`;
